import React from 'react';

class PageNotFound extends React.Component {

  render() {
    return <div>
      <p>Cannot find the page.</p>
    </div>;
  }
}

export default PageNotFound;
